import { CONTRACT_SALES_LISTING } from "./type";

const initalState = {
  contractpostSalesList: {},
};

const approvedSalesListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CONTRACT_SALES_LISTING:
      return {
        ...state,
        contractpostSalesList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default approvedSalesListReducer;
